import { useEffect, useState } from 'react';
import { MEDIA_TYPE } from '@constants/file';

const STORY_RATIO = 9 / 16;
const TOLERANCE = 0.08;

const loadAspectRatio = ({ link, type }) =>
    new Promise(resolve => {
        if (type === MEDIA_TYPE.VIDEO) {
            const video = document.createElement('video');
            video.preload = 'metadata';
            video.onloadedmetadata = () => resolve(video.videoHeight ? video.videoWidth / video.videoHeight : null);
            video.onerror = () => resolve(null);
            video.src = link;
        } else {
            const img = new Image();
            img.onload = () => resolve(img.naturalHeight ? img.naturalWidth / img.naturalHeight : null);
            img.onerror = () => resolve(null);
            img.src = link;
        }
    });

export const useStoryAspectWarning = media => {
    const item = media?.length === 1 && media[0]?.link ? media[0] : null;
    const link = item?.link ?? null;
    const type = item?.type ?? null;
    const [offRatio, setOffRatio] = useState(false);

    useEffect(() => {
        let cancelled = false;
        setOffRatio(false);
        if (!link) return undefined;
        loadAspectRatio({ link, type }).then(ratio => {
            if (!cancelled && ratio != null) {
                setOffRatio(Math.abs(ratio - STORY_RATIO) > TOLERANCE);
            }
        });
        return () => {
            cancelled = true;
        };
    }, [link, type]);

    return offRatio;
};
